/**
 * Frontend runtime configuration.
 *
 * API_BASE: origin of the Worker API. Empty in local dev (Vite proxies /api
 * to wrangler) — set VITE_API_BASE at build time for production Pages
 * deployments, e.g. https://klooma-worker.<account>.workers.dev
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '';

/** Prefix a path with the API origin (no-op in local dev). */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
